function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "7.62 20.84 15.31 26 15.36 15.7 7.62 20.84",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6V6a9,9,0,0,0-9,9h4.18A4.87,4.87,0,1,1,16,19.91h0a4.6,4.6,0,0,1-.64-.05V24H16A9,9,0,0,0,16,6Z",
    style: {
      fill: "#9868b9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.19c12eaa.svg";
export { ForwardRef as ReactComponent };